module.exports = {
    'ru': require('./ru.json'),
    'us': require('./us.json'),
    'il' : require('./il.json')
}